<template>
  <v-card height='100%'>
    <v-card-subtitle>
      {{ $vuetify.lang.t('$vuetify.map.demoVideo.videoType.title') }}
    </v-card-subtitle>
    <v-card-text>
      <v-radio-group v-model="videoType" @change="sendChangedVideoType">
        <v-radio :label="$vuetify.lang.t('$vuetify.map.demoVideo.videoType.demo')" :value="CriticalVideoType.DEMO"></v-radio>
        <v-radio :label="$vuetify.lang.t('$vuetify.map.demoVideo.videoType.dataset')" :value="CriticalVideoType.DATASET"></v-radio>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
import { CriticalVideoType } from '../../../enum'

export default {
  name: 'videoTypeSelector',
  data: () => ({
    videoType: CriticalVideoType.DEMO
  }),
  methods: {
    sendChangedVideoType(value) {
      this.$emit('video-type-changed', value)
    }
  },
  created () {
    this['CriticalVideoType'] = CriticalVideoType
  }
}
</script>

<style scoped>

</style>
